import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DateIcon } from 'foundations-assets/icons/components/DateIcon';
import { Flex } from 'foundations-components/components/Flex';
import { H5 } from 'foundations-components/transitional/components/H5';
import { H6 } from 'foundations-components/transitional/components/H6';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { DealPlanSellerTypename, DealPlanCompanyAssigneeTypename } from '../../__generated__/chirp/com/hubspot/deal/plans/rpc/DealPlanPortalRpc';
import { AvatarDisplay } from 'avatar-components/AvatarDisplay';
import { useOwnerSrc } from '../hooks/useOwnerSrc';
import { getMilestoneAssigneeName } from 'deal-plans-lib/utils/ownerUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function MilestoneDetailsPanel({
  milestone,
  onClose
}) {
  const owner = milestone.owner;
  const isSeller = (owner === null || owner === void 0 ? void 0 : owner.__typename) === DealPlanSellerTypename;
  const getOwnerSrc = useOwnerSrc();
  return /*#__PURE__*/_jsxs(View, {
    borderInlineStartWidth: "100",
    borderInlineStartColor: "border-core-default",
    borderInlineStartStyle: "solid",
    minInlineSize: "385px",
    maxInlineSize: "385px",
    alignSelf: "stretch",
    overflow: "auto",
    backgroundColor: "fill-surface-default",
    children: [/*#__PURE__*/_jsxs(Flex, {
      paddingInline: "400",
      borderBlockEndWidth: "100",
      borderBlockEndColor: "border-core-default",
      borderBlockEndStyle: "solid",
      justifyContent: "space-between",
      paddingBlockStart: "600",
      paddingBlockEnd: "200",
      alignItems: "start",
      children: [/*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dealPlan.details.title"
        })
      }), /*#__PURE__*/_jsx(IconButton, {
        use: "link",
        size: "md",
        onClick: onClose,
        children: /*#__PURE__*/_jsx(RemoveIcon, {
          color: "text-core-default"
        })
      })]
    }), /*#__PURE__*/_jsxs(View, {
      paddingInline: "400",
      paddingBlockStart: "400",
      children: [/*#__PURE__*/_jsx(H6, {
        children: milestone.title
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "200",
        paddingBlockEnd: "200",
        children: [/*#__PURE__*/_jsx(DateIcon, {}), milestone.dueDate ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "dealPlan.details.dueDate_jsx",
          elements: {
            Date: FormattedDateTime
          },
          options: {
            dueDate: milestone.dueDate
          }
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dealPlan.details.noDueDate"
        })]
      }), /*#__PURE__*/_jsx(Text, {
        as: "span",
        color: "text-core-subtle",
        paddingBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dealPlan.details.ownerLabel"
        })
      }), owner ? /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "300",
        children: [/*#__PURE__*/_jsx(AvatarDisplay, {
          src: getOwnerSrc(owner) || undefined,
          type: owner.__typename === DealPlanCompanyAssigneeTypename ? 'company' : 'contact',
          displayName: getMilestoneAssigneeName(owner),
          size: "md"
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "strong",
            children: getMilestoneAssigneeName(owner)
          }), /*#__PURE__*/_jsx(Text, {
            as: "span",
            typography: "body-100",
            color: "text-core-subtle",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: isSeller ? 'dealPlan.details.ownerRoleSeller' : 'dealPlan.details.ownerRoleBuyer'
            })
          })]
        })]
      }) : /*#__PURE__*/_jsx(Text, {
        as: "span",
        color: "text-core-subtle",
        marginInlineStart: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dealPlan.details.unassigned"
        })
      })]
    })]
  });
}